var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcontv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.067,
    height: 28.529,
    viewBox: "0 0 40.067 28.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1988_",
    d: "M38.891,73.72H1.177A1.177,1.177,0,0,0,0,74.9V96.565a1.177,1.177,0,0,0,1.177,1.177H15.884V99.9H12.71a1.177,1.177,0,0,0,0,2.353H27.357a1.177,1.177,0,0,0,0-2.353H24.183V97.742H38.891a1.177,1.177,0,0,0,1.177-1.177V74.9A1.177,1.177,0,0,0,38.891,73.72ZM21.829,99.9H18.238V97.742h3.592Zm15.884-4.507H2.353V76.073H37.714Z",
    transform: "translate(0 -73.72)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcontv);
export default __webpack_public_path__ + "static/media/icontv.d4b2ede8ec0133d1fb44d6f80d8662ce.svg";
export { ForwardRef as ReactComponent };